import { CreditCard as CreditCardIcon, Zap } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

export const CardTypeSelector = () => {
  const { t } = useTranslations("cards");

  return (
    <section className="space-y-2">
      <label className="text-sm font-medium text-foreground">{t("create_card_label_type")}</label>
      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-xl border border-primary bg-primary/5 p-4">
          <span className="mb-2 inline-flex h-9 w-9 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <Zap className="h-4 w-4" />
          </span>
          <div className="text-sm font-medium text-foreground">{t("create_card_type_virtual_title")}</div>
          <div className="mt-0.5 text-xs text-muted-foreground">
            {t("create_card_type_virtual_description")}
          </div>
        </div>
        <div className="relative cursor-not-allowed rounded-xl border border-dashed border-border bg-muted/30 p-4 opacity-75">
          <span className="absolute right-3 top-3 rounded-full bg-secondary px-2 py-0.5 text-[10px] font-medium text-secondary-foreground">
            {t("identity_detail_coming_soon")}
          </span>
          <span className="mb-2 inline-flex h-9 w-9 items-center justify-center rounded-md bg-card text-muted-foreground">
            <CreditCardIcon className="h-4 w-4" />
          </span>
          <div className="text-sm font-medium text-muted-foreground">
            {t("create_card_type_physical_title")}
          </div>
          <div className="mt-0.5 text-xs text-muted-foreground/80">
            {t("create_card_type_physical_description")}
          </div>
        </div>
      </div>
    </section>
  );
};
